import React, { createContext, useState } from "react";

import { useNavigate, useLocation } from "react-router";
import RoutConstants from "../../../constants/routeConstants.json";
export const FanUserDeviceListPageContext = createContext({});
export const FanUserDeviceListPageContextProvider = ({ children }) => {
  const [count, setCount] = useState(8);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const deviceList = location?.state?.result;
  const catogoryId = localStorage.getItem("dashboard_Id");
  const navigateToDeviceDashboard = (modelName) => {

      navigate({
        pathname: RoutConstants.FAN_DEVICE_DATA,
        search: "?fan=singleFan",
      });
   
   
 
    localStorage.setItem("model", modelName);
  };
  const providerValue = {
    count,
    deviceList,
    navigateToDeviceDashboard,
  };
  return (
    <FanUserDeviceListPageContext.Provider value={providerValue}>
      {children}
    </FanUserDeviceListPageContext.Provider>
  );
};
